import Request from "../model/Request";
import Response from "../model/Response";
import {RestClient} from "../util/RestClient";
import {Config} from "../util/Config";
import AgencyDocumentSettings from "../model/agency/AgencyDocumentSettings";
import DocumentIssuerMode from "../entities/DocumentIssuerMode";

export module AgencyDocumentSettingsService {

    export async function get(agencyId?: string): Promise<Response<AgencyDocumentSettings>> {
        const url = Config.get("GET_AGENCY_DOCUMENT_SETTINGS_URL", {agencyId});
        const request = new Request(url);
        const response = await RestClient.get(request);
        if (response.success) {
            return new Response<AgencyDocumentSettings>(true, toSettings(response.data), response.error);
        }
        return new Response<AgencyDocumentSettings>(false, undefined, response.error, response.status);
    }

    export async function update(settings: AgencyDocumentSettings, agencyId?: string): Promise<Response<AgencyDocumentSettings>> {
        const url = Config.get("UPDATE_AGENCY_DOCUMENT_SETTINGS_URL", {agencyId});
        const request = new Request(url, {
            mode: settings.mode,
            name: settings.name,
            phone: settings.phone,
            address: settings.address,
            email: settings.email,
            footerNote: settings.footerNote,
        });
        const response = await RestClient.put(request);
        if (response.success) {
            return new Response<AgencyDocumentSettings>(true, toSettings(response.data), response.error);
        }
        return new Response<AgencyDocumentSettings>(false, undefined, response.error, response.status);
    }

    export async function uploadLogo(base64File: string, agencyId?: string): Promise<Response<AgencyDocumentSettings>> {
        const url = Config.get("UPLOAD_AGENCY_DOCUMENT_LOGO_URL", {agencyId});
        const request = new Request(url, {base64File});
        const response = await RestClient.post(request);
        if (response.success) {
            return new Response<AgencyDocumentSettings>(true, toSettings(response.data), response.error);
        }
        return new Response<AgencyDocumentSettings>(false, undefined, response.error, response.status);
    }

    function toSettings(data: any): AgencyDocumentSettings {
        return new AgencyDocumentSettings(
            data?.mode || DocumentIssuerMode.AGENCY,
            data?.name,
            data?.phone,
            data?.address,
            data?.email,
            data?.logo,
            data?.footerNote,
        );
    }
}
